import { isFieldEmpty } from "@limitless/common/utils";
import { isEmailValid } from "../../../customer/utils";
import { validateFirstName, validateLastName } from "../validators/AboutFormValidator";
const isPartialDobValid = value => {
  if (value === null || Number.isNaN(value)) {
    return false;
  }
  return true;
};

/**
 * we month - 1 here because our platform stores 1 = Jan and JavaScript stores 1 = Feb
 */
export const isValidDate = (year, month, day) => {
  let monthValue = month - 1;
  if (typeof month === "string") {
    monthValue = Number(month - 1).valueOf();
  }
  const d = new Date(year, monthValue, day);

  // eslint-disable-next-line eqeqeq
  if (d.getFullYear() == year && d.getMonth() === monthValue && d.getDate() == day) {
    return true;
  }
  return false;
};

/**
 * Validates the user inputs for the About form
 *
 * @param {object} fields
 */

const calculateAge = dob => {
  const dobAsDate = new Date(dob);
  const ageDifMs = Date.now() - dobAsDate.getTime();
  const ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};
export const validateIdVerification = fields => {
  let fieldErrors = {};
  const {
    dayOfBirth,
    monthOfBirth,
    yearOfBirth,
    firstName,
    lastName
  } = fields;

  //the scenario where the hook isn't fully populated with fields..
  if (!firstName) {
    return {
      fieldErrors,
      isFormInvalid: true
    };
  }
  if (firstName) {
    fieldErrors = {
      ...fieldErrors,
      ...validateFirstName(firstName, true)
    };
  }
  if (lastName) {
    fieldErrors = {
      ...fieldErrors,
      ...validateLastName(lastName, true)
    };
  }
  const joinDob = `${yearOfBirth.value.value}-${monthOfBirth.value.value}-${dayOfBirth.value.value}`;
  const dobPristine = yearOfBirth.pristine || monthOfBirth.pristine || dayOfBirth.pristine;
  const dob = {
    value: joinDob,
    pristine: dobPristine
  };
  if (!dob.pristine) {
    if (!isPartialDobValid(yearOfBirth.value.value) || !isPartialDobValid(monthOfBirth.value.value) || !isPartialDobValid(dayOfBirth.value.value) || !isValidDate(yearOfBirth.value.value, monthOfBirth.value.value, dayOfBirth.value.value)) {
      fieldErrors.dob = "Invalid Date of Birth";
    }
    if (calculateAge(dob.value) < 18) {
      fieldErrors.dob = "You must be 18 to be an Expert";
    }
  }
  Object.keys(fields).map(key => {
    if (fields[key].type === "email") {
      if (!fields[key].pristine && !fields[key].pristine && !isEmailValid(fields[key].value)) {
        fieldErrors[key] = "Email address is not valid";
      } else if (!fields[key].pristine && isFieldEmpty(fields[key].value)) {
        fieldErrors[key] = "Please enter an email address";
      }
    } else if (fields[key].type === "number") {
      if (!fields[key].pristine && !fields[key].value > 0) {
        fieldErrors[key] = "Invalid entry";
      }
    } else {
      // is string type
      if (!fields[key].pristine && isFieldEmpty(fields[key].value) && fields[key].required === true) {
        fieldErrors[key] = "Please enter a value";
      }
    }
  });
  const areSomeEmpty = Object.keys(fields).some(key => {
    const field = fields[key];
    if (field.required === false) {
      return false;
    }
    return isFieldEmpty(field.value);
  });
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || areSomeEmpty;
  return {
    fieldErrors,
    isFormInvalid
  };
};